import styled from 'styled-components';

export const PageMetaInfo = styled.div`
  border-top: 1px solid #808080;
  margin-top: 100px;
  p {
    font-style: italic;
  }
`;
